exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.fix-index[data-v-05e4d8c2] {\n  z-index: 0;\n}\n.fade-enter-active[data-v-05e4d8c2], .fade-leave-active[data-v-05e4d8c2] {\n  transition: opacity 0.4s;\n}\n.fade-enter[data-v-05e4d8c2], .fade-leave-to[data-v-05e4d8c2] {\n  opacity: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-05e4d8c2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/Pluralo.vue
// module id = 2387
// module chunks = 0